import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export function getSaison(dateDebut?: string | Date | number | null): string {
  if (dateDebut) {
    const moisDebut = dayjs(dateDebut).month() + 1;

    if (moisDebut < 3 || moisDebut === 12) {
      return "Hiver";
    }

    if (moisDebut < 6) {
      return "Printemps";
    }

    if (moisDebut < 9) {
      return "Eté";
    }

    if (moisDebut < 12) {
      return "Automne";
    }
  }

  return "NC";
}

export function isBefore(
  date: string | number | Date,
  dateToCompare: string | number | Date,
) {
  return new Date(date).getTime() < new Date(dateToCompare).getTime();
}

export function isAfter(
  date: string | number | Date,
  dateToCompare: string | number | Date,
) {
  return new Date(date).getTime() > new Date(dateToCompare).getTime();
}

export function isBetweenDates(
  date: string | number | Date,
  start: string | number | Date,
  end: string | number | Date,
) {
  const d = new Date(date).getTime();
  return d >= new Date(start).getTime() && d <= new Date(end).getTime();
}

export function daysBetween(
  date1: string | number | Date,
  date2: string | number | Date,
) {
  const diff = new Date(date2).getTime() - new Date(date1).getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function minutesBetween(
  date1: string | number | Date,
  date2: string | number | Date,
) {
  const diff = new Date(date2).getTime() - new Date(date1).getTime();
  return diff >= 0 ? Math.ceil(diff / (1000 * 60)) : 0;
}

export function addYears(date: Date | null, years: number) {
  return date ? dayjs(date).add(years, "year").toDate() : null;
}

export function addMinutes(date: Date | null, minutes: number) {
  return date ? dayjs(date).add(minutes, "minutes").toDate() : null;
}

export function addDays(date: Date, days: number) {
  return dayjs(date).add(days, "day").toDate();
}

export function addMonths(date: Date, months: number) {
  return dayjs(date).add(months, "month").toDate();
}

export function formatFR(date?: Date | string | null, fallback = "") {
  if (!date) return fallback;
  const d = dayjs(date);
  return d.isValid() ? d.format("DD/MM/YYYY") : fallback;
}

export function formatFRDateTime(date: Date) {
  return dayjs(date).format("DD/MM/YYYY HH:mm");
}

export function formatFRTime(date: Date) {
  return dayjs(date).format("HH:mm");
}

export function formatISOShort(date?: Date | Dayjs | string | null) {
  if (!date) return undefined;
  return dayjs(date).format("YYYY-MM-DD");
}

export function getYear4k(date: Date) {
  return dayjs(date).format("YYYY");
}

/**
 * JJ/MM/AAAA -> AAAA-MM-JJ
 */
export const parseToISODate = (dateString: string | null): string | null => {
  if (!dateString) return null;
  const [day, month, year] = dateString.split("/");
  return `${year}-${month}-${day}`;
};

export const parseIntToMonthFR = (mois: number[] | null): string => {
  if (!mois || mois.length === 0) return "-";

  const moisLabels = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];

  return mois.map((m) => moisLabels[m - 1] || m).join(", ");
};

export const isValidFrShort = (date?: string | null): boolean => {
  if (!date) return false;
  return dayjs(date, "DD/MM/YYYY", true).isValid();
};

export const isValidIsoShort = (date?: string | null): boolean => {
  if (!date) return false;
  return dayjs(date, "YYYY-MM-DD", true).isValid();
};

export const parseFrShort = (date?: string | null): dayjs.Dayjs | undefined => {
  if (!date) return undefined;
  const parsed = dayjs(date, "DD/MM/YYYY", true);
  return parsed.isValid() ? parsed : undefined;
};

export function isInvalidDateValue(date?: Date | string | null): boolean {
  if (!date) return false;
  return !dayjs(date).isValid();
}
